<template>
  <!-- TODO:
        - Validações
        - Tipo do arquivo p/ upload
  -->
  <div class="home-televendas">
    <mf-loading-dialog :loading="loading">
      <v-container class="pa-0" fluid>
        <v-card class="my-3 px-6">
          <v-card-title>
            <span class="section-title">Geral</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="4" class="mb-0">
                <label class="detail-title">URL*</label> (sem https://)
                <v-text-field v-model="url" class="mb-0" suffix=".televendas.app" outlined />
              </v-col>
              <v-spacer />
            </v-row>
            <v-row>
              <v-col class="py-0">
                <span class="section-title">Entrega</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="pt-6">
                <v-checkbox v-model="ecommerceConfiguration.has_delivery" hide-details single-line class="mb-0" label="Entrega"></v-checkbox>
              </v-col>
              <v-spacer />
              <v-col cols="3" class="mb-0">
                <label class="detail-title">Valor mínimo</label>
                <v-text-field v-model="ecommerceConfiguration.minimum_delivery_cart_price" v-money="costInputConfigs" class="mb-0" outlined />
              </v-col>
              <v-spacer />
              <v-col cols="3" class="mb-0">
                <label class="detail-title">Taxa</label>
                <v-text-field v-model="ecommerceConfiguration.delivery_rate" v-money="costInputConfigs" class="mb-0" outlined />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <span class="section-title">Retirada</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="pt-6">
                <v-checkbox v-model="ecommerceConfiguration.has_pickup" hide-details single-line class="mb-0" label="Retirada"></v-checkbox>
              </v-col>
              <v-spacer />
              <v-col cols="3" class="mb-0">
                <label class="detail-title">Valor mínimo</label>
                <v-text-field v-model="ecommerceConfiguration.minimum_pickup_cart_price" v-money="costInputConfigs" class="mb-0" outlined />
              </v-col>
              <v-spacer />
              <v-col cols="3" class="mb-0">
                <label class="detail-title">Taxa</label>
                <v-text-field v-model="ecommerceConfiguration.pickup_rate" v-money="costInputConfigs" class="mb-0" outlined />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <span class="section-title">Métodos de pagamento</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="pt-0">
                <v-checkbox v-model="ecommerceConfiguration.payment_methods.CASH" hide-details single-line class="mb-0" label="Dinheiro"></v-checkbox>
              </v-col>
              <v-spacer />
              <v-col cols="3" class="pt-0">
                <v-checkbox
                  v-model="ecommerceConfiguration.payment_methods.DEBIT_CARD"
                  hide-details
                  single-line
                  class="mb-0"
                  label="Cartão de débito"
                ></v-checkbox>
              </v-col>
              <v-spacer />
              <v-col cols="3" class="pt-0">
                <v-checkbox
                  v-model="ecommerceConfiguration.payment_methods.CREDIT_CARD"
                  hide-details
                  single-line
                  class="mb-0"
                  label="Cartão de crédito"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row class="pt-12 pb-0">
              <v-col class="py-0">
                <span class="section-title">Substituição de produtos</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="pt-0">
                <v-checkbox
                  v-model="ecommerceConfiguration.missing_product_policies.SWAP"
                  hide-details
                  single-line
                  class="mb-0"
                  label="Substituir por equivalente"
                ></v-checkbox>
              </v-col>
              <v-spacer />
              <v-col cols="3" class="pt-0">
                <v-checkbox
                  v-model="ecommerceConfiguration.missing_product_policies.REMOVE"
                  hide-details
                  single-line
                  class="mb-0"
                  label="Remover item"
                ></v-checkbox>
              </v-col>
              <v-spacer />
              <v-col cols="3" class="pt-0">
                <v-checkbox
                  v-model="ecommerceConfiguration.missing_product_policies.CANCEL"
                  hide-details
                  single-line
                  class="mb-0"
                  label="Cancelar compra"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="my-3 px-6">
          <v-card-title>
            <span class="section-title">Assets</span>
          </v-card-title>
          <v-card-text>
            <v-row align="end">
              <v-col cols="6" class="mb-0" align="center">
                <v-row justify="center">
                  <img :src="logoUrl" height="140" width="140" />
                </v-row>
                <v-row justify="center">
                  <mf-button class="mt-5" label="Alterar logo" @click="setLogoImage" />
                  <input id="logo-file-input" ref="logo-file-input" class="hidden-input" type="file" @input="readLogoFile($event)" />
                </v-row>
              </v-col>
              <v-spacer />
              <v-col cols="4" class="mb-0" align="center">
                <v-row justify="center">
                  <img :src="faviconUrl" height="16" width="16" />
                </v-row>
                <v-row justify="center">
                  <mf-button class="mt-5" label="Alterar favicon" @click="setFaviconImage" />
                  <input id="favicon-file-input" ref="favicon-file-input" class="hidden-input" type="file" @input="readFaviconFile($event)" />
                </v-row>
              </v-col>
              <v-spacer />
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="my-3 px-6">
          <v-card-title>
            <span class="section-title">Cores</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="3" class="mb-0">
                <label class="detail-title">Cor primária*</label>
                <v-text-field v-model="colors.primary" v-mask="'!#XXXXXX'" class="mb-0" outlined>
                  <template v-slot:append-outer>
                    <div class="color-box" :style="isValidHexColor(colors.primary) ? { backgroundColor: colors.primary } : null">
                      <span v-if="!isValidHexColor(colors.primary)">x</span>
                    </div>
                  </template>
                </v-text-field>
                <label class="detail-title">Fonte da cor primária*</label>
                <v-text-field v-model="colors.font_primary" v-mask="'!#XXXXXX'" class="mb-0" outlined>
                  <template v-slot:append-outer>
                    <div class="color-box" :style="isValidHexColor(colors.font_primary) ? { backgroundColor: colors.font_primary } : null">
                      <span v-if="!isValidHexColor(colors.font_primary)">x</span>
                    </div>
                  </template>
                </v-text-field>
              </v-col>
              <v-spacer />
              <v-col cols="3" class="mb-0">
                <label class="detail-title">Cor secundária*</label>
                <v-text-field v-model="colors.secondary" v-mask="'!#XXXXXX'" class="mb-0" outlined>
                  <template v-slot:append-outer>
                    <div class="color-box" :style="isValidHexColor(colors.secondary) ? { backgroundColor: colors.secondary } : null">
                      <span v-if="!isValidHexColor(colors.secondary)">x</span>
                    </div>
                  </template>
                </v-text-field>
                <label class="detail-title">Fonte da cor secundária*</label>
                <v-text-field v-model="colors.font_secondary" v-mask="'!#XXXXXX'" class="mb-0" outlined>
                  <template v-slot:append-outer>
                    <div class="color-box" :style="isValidHexColor(colors.font_secondary) ? { backgroundColor: colors.font_secondary } : null">
                      <span v-if="!isValidHexColor(colors.font_secondary)">x</span>
                    </div>
                  </template>
                </v-text-field>
              </v-col>
              <v-spacer />
              <v-col cols="3" class="mb-0">
                <label class="detail-title">Cor terciária*</label>
                <v-text-field v-model="colors.tertiary" v-mask="'!#XXXXXX'" class="mb-0" outlined>
                  <template v-slot:append-outer>
                    <div class="color-box" :style="isValidHexColor(colors.tertiary) ? { backgroundColor: colors.tertiary } : null">
                      <span v-if="!isValidHexColor(colors.tertiary)">x</span>
                    </div>
                  </template>
                </v-text-field>
                <label class="detail-title">Fonte da cor terciária*</label>
                <v-text-field v-model="colors.font_tertiary" v-mask="'!#XXXXXX'" class="mb-3" outlined>
                  <template v-slot:append-outer>
                    <div class="color-box" :style="isValidHexColor(colors.font_tertiary) ? { backgroundColor: colors.font_tertiary } : null">
                      <span v-if="!isValidHexColor(colors.font_tertiary)">x</span>
                    </div>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="my-3 px-6">
          <v-card-title>
            <span class="section-title">Mensagem de novo pedido</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col class="pa-0 pl-3">
                <span class="section-title">Destinatários</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="py-0">
                <v-text-field
                  v-model="newRecipient"
                  v-mask="['+55 (##) #####-####', '+55 (##) ####-####']"
                  outlined
                  append-outer-icon="add"
                  hide-details
                  @click:append-outer="addRecipient"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-chip-group show-arrows active-class="primary--text">
                  <v-chip v-for="(recipient, index) in messages.new.recipients" :key="index" small close :ripple="false" @click:close="removeRecipient(index)">
                    <span>{{ formatNumber(recipient) }}</span>
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pa-0 pl-3">
                <span class="section-title">Mensagem</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5" class="mb-0">
                <label class="detail-title">Entrega*</label>
                <v-textarea v-model="messages.new.delivery" height="110" counter="160" no-resize outlined />
              </v-col>
              <v-spacer />
              <v-col cols="5" class="mb-0">
                <label class="detail-title">Retirada*</label>
                <v-textarea v-model="messages.new.pickup" height="110" counter="160" no-resize outlined />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="my-3 px-6">
          <v-card-title>
            <span class="section-title">Mensagens</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col class="pa-0 pl-3">
                <span class="section-title">Confirmado</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5" class="mb-0">
                <label class="detail-title">Entrega*</label>
                <v-textarea v-model="messages.confirmed.delivery" height="110" counter="160" no-resize outlined />
              </v-col>
              <v-spacer />
              <v-col cols="5" class="mb-0">
                <label class="detail-title">Retirada*</label>
                <v-textarea v-model="messages.confirmed.pickup" height="110" counter="160" no-resize outlined />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pa-0 pl-3">
                <span class="section-title">Separação</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5" class="mb-0">
                <label class="detail-title">Entrega*</label>
                <v-textarea v-model="messages.separation.delivery" height="110" counter="160" no-resize outlined />
              </v-col>
              <v-spacer />
              <v-col cols="5" class="mb-0">
                <label class="detail-title">Retirada*</label>
                <v-textarea v-model="messages.separation.pickup" height="110" counter="160" no-resize outlined />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pa-0 pl-3">
                <span class="section-title">Aguardando retirada/entrega</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5" class="mb-0">
                <label class="detail-title">Entrega*</label>
                <v-textarea v-model="messages.awaiting.delivery" height="110" counter="160" no-resize outlined />
              </v-col>
              <v-spacer />
              <v-col cols="5" class="mb-0">
                <label class="detail-title">Retirada*</label>
                <v-textarea v-model="messages.awaiting.pickup" height="110" counter="160" no-resize outlined />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pa-0 pl-3">
                <span class="section-title">Concluído</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5" class="mb-0">
                <label class="detail-title">Entrega*</label>
                <v-textarea v-model="messages.concluded.delivery" height="110" counter="160" no-resize outlined />
              </v-col>
              <v-spacer />
              <v-col cols="5" class="mb-0">
                <label class="detail-title">Retirada*</label>
                <v-textarea v-model="messages.concluded.pickup" height="110" counter="160" no-resize outlined />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pa-0 pl-3">
                <span class="section-title">Cancelado</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5" class="mb-0">
                <label class="detail-title">Entrega*</label>
                <v-textarea v-model="messages.canceled.delivery" height="110" counter="160" no-resize outlined />
              </v-col>
              <v-spacer />
              <v-col cols="5" class="mb-0">
                <label class="detail-title">Retirada*</label>
                <v-textarea v-model="messages.canceled.pickup" height="110" counter="160" no-resize outlined />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="my-3 px-6 pb-3">
          <v-card-title>
            <span class="section-title">Lojas</span>
          </v-card-title>
          <v-card-text>
            <v-row v-for="(unit, index) in units" :key="index">
              <v-col class="my-0 py-0">
                <v-checkbox
                  v-model="unit.ecommerce.active"
                  hide-details
                  single-line
                  class="mb-0"
                  :label="`${unit.id_erp} - ${unit.name} - ${unit.address}`"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="my-3 px-6 pb-3">
          <v-card-title>
            <span class="section-title">Alertas</span>
          </v-card-title>
          <v-card-text>
            <v-row v-for="(alert, index) in alerts" :key="index" align="center" class="pb-4">
              <v-col class="my-0 py-0" cols="6">
                <v-textarea v-model="alerts[index]" hide-details height="110" no-resize outlined @click:append="alerts.splice(index, 1)">
                  <template #append> <mf-icon icon="delete" /> </template
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col align="center" cols="6">
                <mf-icon @click="alerts.push('')">add</mf-icon>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-row class="buttons-row">
          <v-spacer />
          <mf-button label="Alterar" @click="save" />
        </v-row>
      </v-container>
    </mf-loading-dialog>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { VMoney } from 'v-money'
import { localeString } from '@/config/helpers.js'
import { deepDelete } from '@/helpers/deepDelete.js'
import { phoneNumberFormat } from '@/helpers/phoneNumberFormat.js'
import { sanitizeUnits } from '@/helpers/units'

const QUERY_UNITS = gql`
  query Units {
    units: allUnits {
      _id
      id_erp
      name
      address
      ecommerce {
        active
      }
    }
  }
`

const QUERY_ALERTS = gql`
  query Alerts {
    alerts(ecommerce: true)
  }
`

const QUERY_CONFIGURATION = gql`
  query AppConfiguration {
    configuration: appConfiguration {
      ecommerce {
        active
        has_delivery
        has_pickup
        minimum_delivery_cart_price
        minimum_pickup_cart_price
        pickup_rate
        delivery_rate
        payment_methods
        missing_product_policies
      }
    }
  }
`

const QUERY_ACCOUNT = gql`
  query Account {
    account {
      channels {
        ecommerce {
          messages {
            new {
              delivery
              pickup
              recipients
            }
            confirmed {
              delivery
              pickup
            }
            separation {
              delivery
              pickup
            }
            awaiting {
              delivery
              pickup
            }
            concluded {
              delivery
              pickup
            }
            canceled {
              delivery
              pickup
            }
          }
          build {
            url
            colors {
              primary
              font_primary
              secondary
              font_secondary
              tertiary
              font_tertiary
            }
            assets {
              logo
              favicon
            }
          }
        }
      }
    }
  }
`

const MUTATION_ECOMMERCE = gql`
  mutation UpdateEcommerceConfiguration(
    $url: String!
    $configuration: EcommerceConfigurationInput!
    $assets: EcommerceBuildAssetsInput!
    $colors: EcommerceBuildColorsInput!
    $messages: EcommerceMessagesInput!
    $units: [ID]!
    $alerts: [String]!
  ) {
    updateEcommerceConfiguration(
      url: $url
      configuration: $configuration
      assets: $assets
      colors: $colors
      messages: $messages
      units: $units
      alerts: $alerts
    )
  }
`

export default {
  directives: { money: VMoney },
  data: () => ({
    saving: false,
    colors: {},
    url: '',
    assets: {},
    newRecipient: '',
    ecommerceConfiguration: {
      has_delivery: false,
      has_pickup: false,
      delivery_rate: '',
      pickup_rate: '',
      minimum_delivery_cart_price: '',
      minimum_pickup_cart_price: '',
      payment_methods: {},
      missing_product_policies: {},
    },
    units: [],
    localAssets: {
      logo: null,
      logoLocalUrl: null,
      favicon: null,
      faviconLocalUrl: null,
    },
    messages: {
      new: {
        recipients: [],
      },
      confirmed: {},
      separation: {},
      awaiting: {},
      concluded: {},
      canceled: {},
    },
    costInputConfigs: { decimal: ',', thousands: '.', prefix: 'R$ ', precision: 2 },
  }),
  computed: {
    logoUrl() {
      return this.localAssets.logoLocalUrl || this.assets.logo
    },
    faviconUrl() {
      return this.localAssets.faviconLocalUrl || this.assets.favicon
    },
    loading() {
      return (
        this.saving ||
        this.$apollo.queries.configuration.loading ||
        this.$apollo.queries.account.loading ||
        this.$apollo.queries.units.loading ||
        this.$apollo.queries.alerts.loading
      )
    },
  },
  apollo: {
    alerts: {
      query: QUERY_ALERTS,
    },
    units: {
      query: QUERY_UNITS,
      result: function ({ data: { units } = {}, stale }) {
        if (stale === false) {
          this.units = sanitizeUnits(units).map((unit) => {
            if (!unit.ecommerce) unit.ecommerce = { active: false }
            return unit
          })
        }
      },
    },
    configuration: {
      query: QUERY_CONFIGURATION,
      result: function ({ data: { configuration } = {}, stale }) {
        if (stale === false && configuration.ecommerce) {
          this.ecommerceConfiguration.has_delivery = configuration.ecommerce.has_delivery
          this.ecommerceConfiguration.has_pickup = configuration.ecommerce.has_pickup

          if (configuration.ecommerce && configuration.ecommerce.payment_methods) {
            this.ecommerceConfiguration.payment_methods = configuration.ecommerce.payment_methods.reduce((acc, method) => ({ ...acc, [method]: true }), {})
          } else this.ecommerceConfiguration.payment_methods = {}

          if (configuration.ecommerce && configuration.ecommerce.missing_product_policies) {
            this.ecommerceConfiguration.missing_product_policies = configuration.ecommerce.missing_product_policies.reduce(
              (acc, method) => ({ ...acc, [method]: true }),
              {}
            )
          } else this.ecommerceConfiguration.missing_product_policies = {}

          this.ecommerceConfiguration.delivery_rate = localeString(configuration.ecommerce.delivery_rate, 2)
          this.ecommerceConfiguration.pickup_rate = localeString(configuration.ecommerce.pickup_rate, 2)
          this.ecommerceConfiguration.minimum_delivery_cart_price = localeString(configuration.ecommerce.minimum_delivery_cart_price, 2)
          this.ecommerceConfiguration.minimum_pickup_cart_price = localeString(configuration.ecommerce.minimum_pickup_cart_price, 2)
        }
      },
    },
    account: {
      query: QUERY_ACCOUNT,
      result: function ({ data: { account } = {}, stale }) {
        if (stale === false && account.channels && account.channels.ecommerce) {
          if (account.channels.ecommerce.build) {
            this.colors = account.channels.ecommerce.build.colors
            this.url = account.channels.ecommerce.build.url.replace('.televendas.app', '')
            this.assets = account.channels.ecommerce.build.assets
          }
          if (account.channels.ecommerce.messages) this.messages = account.channels.ecommerce.messages
          if (!this.messages.new) this.messages.new = { recipients: [] }
        }
      },
    },
  },
  mounted() {
    document.title = 'Configurações Televendas'
  },
  methods: {
    formatNumber(number) {
      return phoneNumberFormat(number)
    },
    addRecipient() {
      this.messages.new.recipients.push(this.newRecipient.replace(/[^0-9]/g, ''))
      this.newRecipient = ''
    },
    removeRecipient(index) {
      this.messages.new.recipients.splice(index, 1)
    },
    isValidHexColor(color) {
      return /^#[0-9A-F]{6}$/i.test(color)
    },
    parseMoney(value) {
      return parseFloat(value.replace('R$ ', '').replace(',', '.'))
    },
    readLogoFile(event) {
      this.localAssets.logo = event.target.files[0]
      this.localAssets.logoLocalUrl = URL.createObjectURL(this.localAssets.logo)
    },
    setLogoImage() {
      this.$refs['logo-file-input'].click()
      document.querySelector('#logo-file-input').value = '' // This enables secting the same file again
    },
    readFaviconFile(event) {
      this.localAssets.favicon = event.target.files[0]
      this.localAssets.faviconLocalUrl = URL.createObjectURL(this.localAssets.favicon)
    },
    setFaviconImage() {
      this.$refs['favicon-file-input'].click()
      document.querySelector('#favicon-file-input').value = '' // This enables secting the same file again
    },
    async save() {
      this.saving = true
      const variables = {
        url: `${this.url}.televendas.app`,
        configuration: {
          has_delivery: this.ecommerceConfiguration.has_delivery,
          has_pickup: this.ecommerceConfiguration.has_pickup,
          minimum_delivery_cart_price: this.parseMoney(this.ecommerceConfiguration.minimum_delivery_cart_price),
          minimum_pickup_cart_price: this.parseMoney(this.ecommerceConfiguration.minimum_pickup_cart_price),
          delivery_rate: this.parseMoney(this.ecommerceConfiguration.delivery_rate),
          pickup_rate: this.parseMoney(this.ecommerceConfiguration.pickup_rate),
          payment_methods: Object.entries(this.ecommerceConfiguration.payment_methods).reduce((acc, [key, value]) => (value ? [...acc, key] : acc), []),
          missing_product_policies: Object.entries(this.ecommerceConfiguration.missing_product_policies).reduce(
            (acc, [key, value]) => (value ? [...acc, key] : acc),
            []
          ),
        },
        assets: {
          logo: this.localAssets.logo,
          favicon: this.localAssets.favicon,
        },
        colors: this.colors,
        messages: this.messages,
        units: this.units.reduce((acc, unit) => (unit.ecommerce.active ? [...acc, unit._id] : acc), []),
        alerts: this.alerts.filter((alert) => alert !== ''),
      }
      deepDelete(variables, '__typename')
      await this.$apollo.mutate({
        mutation: MUTATION_ECOMMERCE,
        variables,
      })
      this.saving = false
      this.$apollo.provider.defaultClient.reFetchObservableQueries()
    },
  },
}
</script>

<style lang="scss">
.home-televendas {
  .hidden-input {
    display: none;
  }
  .buttons-row {
    padding: 5px 30px 5px 30px;
  }
  .section-title {
    font-size: 20px;
    font-weight: bold;
  }
  .detail-title {
    opacity: 0.8;
    font-size: 15px;
    font-weight: bold;
    line-height: 1.2;
    letter-spacing: 0.24px;
    color: $preto;
    margin-bottom: 8px;
  }
  .color-box {
    width: 24px;
    height: 24px;
    border: 1px solid $cinza-d10;
    border-radius: 4px;
    text-align: center;
    span {
      color: $cinza-d10;
      font-weight: bold;
    }
  }
  .alert-chip {
    display: block;
    max-width: 100px;
  }
}
</style>
